import DropdownComponent from "presentation/components/Shared/DropdownComponent";
import InputNumberComponent from "presentation/components/Shared/InputNumberComponent";
import InputTextComponent from "presentation/components/Shared/InputTextComponent";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

export const DistanceModal = ({
  distanceType,
  distance,
  setDistance,
  visible,
  onHide,
  onSave,
}: {
  distanceType: any;
  distance: any;
  setDistance: (value: any) => void;
  visible: boolean;
  onHide: () => void;
  onSave: () => void;
}) => {
  return (
    <Dialog
      header="Editar Distância"
      visible={visible}
      style={{ width: "30vw" }}
      onHide={onHide}
      modal
    >
      <div className="parameter-grid mt-5">
        <div className="parameter-4-cols">
          <DropdownComponent
            options={distanceType}
            label={`Tipo`}
            fieldName="type"
            currentObject={distance}
            getValue={distance?.type ?? ""}
            setValue={setDistance}
          />
        </div>
        <div className="parameter-4-cols">
          <InputTextComponent
            label="Origem"
            fieldName="locationOrigin"
            currentObject={distance}
            getValue={distance?.locationOrigin}
            setValue={setDistance}
          />
        </div>
        <div className="parameter-4-cols">
          <InputTextComponent
            label="Destino"
            fieldName="locationDestination"
            currentObject={distance}
            getValue={distance?.locationDestination}
            setValue={setDistance}
          />
        </div>
        <div className="parameter-4-cols">
          <InputNumberComponent
            label="Distância"
            fieldName="distanceKm"
            currentObject={distance}
            getValue={distance?.distanceKm}
            setValue={setDistance}
          />
        </div>
      </div>
      <div className="col-12 flex justify-content-end gap-2 mt-3">
        <Button
          label="Cancelar"
          onClick={onHide}
          className="p-button-secondary"
        />
        <Button
          label="Atualizar"
          onClick={onSave}
          className="button-toolbar "
        />
      </div>
    </Dialog>
  );
};
